import * as Yup from 'yup';
const minEmail = 'Ingresa un correo electrónico válido';
const maxEmail = 'Ingresa un correo electrónico más pequeño';
const invalidEmail = 'Ingresa un correo electrónico válido';
const minPassword = 'La contraseña debe tener al menos 8 caracteres';
const maxPassword = 'La contraseña debe tener máximo 16 caracteres';
const minName = 'Nombre muy corto';
const maxName = 'Nombre muy largo';
const minLastName = 'Apellido muy corto';
const maxLastName = 'Apellido muy largo';
const minTel = 'Debe tener exactamente 10 dígitos númericos';
const maxTel = 'Debe tener exactamente 10 dígitos númericos';

const minCedula = 'Número de cédula profesional muy corto';
const maxCedula = 'Número de cédula profesional muy largo';
const minDes = 'Descripción muy corta';
const maxDes = 'Descripción muy larga';
const minArraySpecialties = 'Selecciona una opción';
const minArrayLanguages = 'Selecciona una opción';
const maxArrayLanguages = 'Puedes añadir hasta cinco';
const minProfessinalID = 'Debe tener al menos 4 dígitos';
const maxProfessinalID = 'Debe tener máximo 8 dígitos';
const requiredField = 'Campo obligatorio';
const emptyError = 'Por favor llena todos los campos antes de continuar';
const minOp = 'La opinion es muy corta';
const maxOp = 'La opinion es muy larga';
const telLADA = 'Debe tener exactamente 10 dígitos númericos incluyendo la lada';

const fullName = /^[a-zA-Z]{4,}(?: [a-zA-Z]+){0,2}$/
const linkedIn = /((https?:\/\/)?((www|\w\w)\.)?linkedin\.com\/)((([\w]{2,3})?)|([^\/]+\/(([\w|\d-_&#%?=])+\/?){1,}))$/;
const twitter = /(?:http:\/\/)?(?:www\.)?twitter\.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w\-]*\/)*([\w\-]*)/
const facebook = /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/
const instagram = /(?:(?:http|https):\/\/)?(?:www.)?instagram.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/
const youtube = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
const textoyacentos = /^[A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙñÑ ]*$/;
const url = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

// const onlyNumber = 'Solo se permiten numeros';
// const phoneRegExp = /(01-52|0152|0152-|01-52-)?(\d{2}-\d{4}-\d{4}|\d{10}|\d{8}|\d{4}-\d{4})/g;

//@"[ A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ.-]+"

export const personalDataClient = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(20, maxName),
  lastName: Yup.string()
    .min(3, minName)
    .max(20, maxName),
});

export const personalDataClientSocial = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .required(requiredField),
  lastName: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .required(requiredField),
});

export const validationLawyer = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  firstLastName: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  secondLastName: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  gender: Yup.string().required(requiredField),
});
export const validationLawFirm = Yup.object().shape({
  officeName: Yup.string()
    .min(3, minName)
    .max(80, maxName)
    .required(requiredField),
  name: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  firstLastName: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  secondLastName: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
});
export const validationContactInfo = Yup.object().shape({
  email: Yup.string()
    .min(3, minEmail)
    .max(255, maxEmail)
    .email(invalidEmail)
    .required(requiredField),
  password: Yup.string()
    .min(8, minPassword)
    .max(16, maxPassword)
    .required(requiredField),
  specialties: Yup.string()
    .min(1, minArraySpecialties)
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  /* professionalID: Yup.string()
    .matches(/^[0-9]*$/, 'Debe tener sólo dígitos númericos')
    .min(4, minProfessinalID)
    .max(8, maxProfessinalID)
    .required(requiredField), */
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    'Debes aceptar los términos y condiciones'
  ),
});
export const validationUpdatePassword = Yup.object().shape({
  currentPassword: Yup.string()
    .min(8, minPassword)
    .max(16, maxPassword)
    .required(requiredField),
  newPassword: Yup.string()
    .min(8, minPassword)
    .max(16, maxPassword)
    .notOneOf(
      [Yup.ref('currentPassword')],
      'La nueva contraseña debe ser diferente a la anterior'
    )
    .required(requiredField),
  confirmPassword: Yup.string()
    .min(8, minPassword)
    .max(16, maxPassword)
    .required(requiredField)
    .oneOf(
      [Yup.ref('newPassword'), null],
      'La confirmación debe coincidir con la nueva contraseña'
    ),
});
export const phoneNumberValidation = Yup.object().shape({
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    // .required(requiredField),
});

export const webinarValidation = Yup.object().shape({
  role: Yup.string()
    .required(requiredField),
  name: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  lastName: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    'Debes aceptar los términos y condiciones'
  ),
});

export const leadsValidation = Yup.object().shape({
  role: Yup.string()
    .required(requiredField),
  name: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  lastName: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    'Debes aceptar los términos y condiciones'
  ),
});

export const freemiumLandingValidation = Yup.object().shape({
  role: Yup.string()
    .required(requiredField),
  name: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  lastName: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    'Debes aceptar los términos y condiciones'
  ),
});

export const schemaPayment = Yup.object().shape({
  nombre: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  apellido: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  cp: Yup.string()
    .matches(/^[0-9]{9}$/, 'Debe tener exactamente 5 dígitos númericos')
    .required(requiredField),
  pais: Yup.string('Por favor, llenar el campo con un correo válido.').required(
    requiredField
  ),
  estado: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  ciudad: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  colonia: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  calle: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
});

export const validationContactInfoAbout = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  firstLastName: Yup.string()
    .min(3, minLastName)
    .max(30, maxLastName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  secondLastName: Yup.string()
    .min(3, minLastName)
    .max(30, maxLastName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  phone: Yup.string()
    .matches(/^\d{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  expYears: Yup.string()
    .min(1, 'Años de experiencia no válidos')
    .max(25, 'Años de experiencia no válidos'),
  cedula: Yup.string()
    .min(5, minCedula)
    .max(9, maxCedula),
  colegNumber: Yup.string()
    .min(5, 'Número de colegiado muy corto')
    .max(19, 'Número de colegiado muy largo'),
  languages: Yup.array()
    .max(5, maxArrayLanguages),
});

export const validationContactInfoAboutFirm = Yup.object().shape({
  officeName: Yup.string()
    .min(3, minName)
    .max(80, maxName)
    .required(requiredField),
  phone: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  expYears: Yup.string()
    .min(1, 'Años de experiencia no válidos')
    .max(25, 'Años de experiencia no válidos'),
});

export const validationContactFirm = Yup.object().shape({
  phone: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos'),
  movil: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos'),
  whats: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos'),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.'),
  blog: Yup.string()
    .matches(url, 'Por favor, llenar el campo con un url válido.'),
});

export const validationContactLawyer = Yup.object().shape({
  phone: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos'),
  movil: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos'),
  whats: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos'),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.'),
  blog: Yup.string()
    .matches(url, 'Por favor, llenar el campo con un url válido.'),
});

export const validationSocialNetwork = Yup.object().shape({
  linkedIn: Yup.string()
    .matches(linkedIn, 'Por favor, llenar el campo con un url válido'),
  twitter: Yup.string()
    .matches(twitter, 'Por favor, llenar el campo con un url válido'),
  facebook: Yup.string()
    .matches(facebook, 'Por favor, llenar el campo con un url válido'),
  instagram: Yup.string()
    .matches(instagram, 'Por favor, llenar el campo con un url válido'),
  youtube: Yup.string()
    .matches(youtube, 'Sólo se aceptan videos de Youtube'),
});

export const validationCollaboratorPosition = Yup.object().shape({
  collaboratorPosition: Yup.string()
    .required(requiredField),
});

export const validationAddingPublication = Yup.object().shape({  
  publicationsLawyer: Yup.array().of(Yup.object().shape({
    url: Yup.string()
      .matches(url, 'Por favor, llenar el campo con un url válido.'),
  })),
});

export const validationAdminLawyerFilter = Yup.object().shape({  
  name: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios'),
  firstLastName: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios'),
  secondLastName: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios'),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.'),
});

export const validationAddAdminLawyer = Yup.object().shape({
  gender: Yup.string()
    .required(requiredField),
  name: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios')
    .required(requiredField),
  firstLastName: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios')
    .required(requiredField),
  secondLastName: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios')
    .required(requiredField),
  phone: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  professionalLicense: Yup.string()
    .min(5, minCedula)
    .max(9, maxCedula)
    .required(requiredField),
  specialties: Yup.array()
    .min(1, minArraySpecialties)
    .required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(requiredField),
  password: Yup.string()
    .min(8, 'La contraseña debe tener entre 8 y 16 caracteres alfanuméricos')
    .max(16, 'La contraseña debe tener entre 8 y 16 caracteres alfanuméricos')
    .required(requiredField)
});

export const validationAdminLawyerFirmFilter = Yup.object().shape({  
  name: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios'),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.'),
});

export const validationAddAdminLawyerFirm = Yup.object().shape({  
  lawFirmName: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios')
    .required(requiredField),
  specialty: Yup.string()
    .required(requiredField),
  phone: Yup.string()
    .min(10, 'Debe tener exactamente 10 dígitos númericos')
    .max(10, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  professionalLicense: Yup.string()
    .min(5, minCedula)
    .max(9, maxCedula)
    .required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(requiredField),
  password: Yup.string()
    .min(8, 'La contraseña debe tener entre 8 y 16 caracteres alfanuméricos')
    .max(16, 'La contraseña debe tener entre 8 y 16 caracteres alfanuméricos')
    .required(requiredField)
});

export const validationClientFilter = Yup.object().shape({  
  name: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios'),
  lastName: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios'),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.'),
});

export const validationContactCenterFilter = Yup.object().shape({  
  completeName: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios'),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.'),
});

export const validationACC = Yup.object().shape({  
  names: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras y espacios')
    .required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(requiredField),
  password: Yup.string()
    .min(8, 'La contraseña debe tener entre 8 y 16 caracteres alfanuméricos')
    .max(16, 'La contraseña debe tener entre 8 y 16 caracteres alfanuméricos')
    .required(requiredField)
});

export const validationPublishResponse = Yup.object().shape({  
  communityAnswer: Yup.string()
    .min(10, 'Respuesta muy corta')
    .required(requiredField)
});

export const validationAddingLawyer = Yup.object().shape({
  nameLawyer: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letras')
    .required(requiredField),
  firstLastname: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letras')
    .required(requiredField),
  secondLastName: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letras')
    .required(requiredField),
  cedula: Yup.string()
    .min(5, minCedula)
    .max(9, maxCedula),
  specialties: Yup.string()
    .min(1, minArraySpecialties)
    .required(requiredField),
  education: Yup.array().of(Yup.object().shape({
    receivedGradeStudy: Yup.string()
      .matches(textoyacentos, 'Sólo se aceptan letras'),
    discipline: Yup.string()
      .matches(textoyacentos, 'Sólo se aceptan letras'),
  })),
  laboral: Yup.array().of(Yup.object().shape({
    companyPosition: Yup.string()
      .matches(textoyacentos, 'Sólo se aceptan letras'),
  })),
});

export const validationAddingSpecialty = Yup.object().shape({
  specialties: Yup.array().of(Yup.object().shape({
    specialty: Yup.string()
      .required()
  })),
});

export const validationAddingHolder = Yup.object().shape({
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(emptyError),
  nameHolder: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letras')
    .required(requiredField),
  firstLastname: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letras')
    .required(requiredField),
  secondLastName: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras'), // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letras')
  cedula: Yup.string()
    .min(5, minCedula)
    .max(9, maxCedula),
  specialties: Yup.string()
    .min(1, minArraySpecialties)
    .required(requiredField),
  educationHolder: Yup.array().of(Yup.object().shape({
    receivedGradeStudy: Yup.string()
      .matches(textoyacentos, 'Sólo se aceptan letras'),
    discipline: Yup.string()
      .matches(textoyacentos, 'Sólo se aceptan letras'),
  })),
  holderLanguages: Yup.array()
    .min(1, minArrayLanguages)
    .max(5, maxArrayLanguages)
    .required(requiredField),
  laboralHolder: Yup.array().of(Yup.object().shape({
    companyPosition: Yup.string()
      .matches(textoyacentos, 'Sólo se aceptan letras'),
  })),
});

export const validationAddingLawyerTitular = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
    firstLastName: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  secondLastName: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  cedula: Yup.string()
    .min(5, minCedula)
    .max(9, maxCedula),
  nameUniversity: Yup.string()
    .min(3, minName)
    .max(80, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras'), // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    specialtiesTitular: Yup.string()
    .min(1, minArraySpecialties)
    .required(requiredField),
  awards: Yup.string()
    .min(3, minName)
    .max(500, maxName),
    experienceTitutar: Yup.string()
    .min(10, minDes)
    .max(2000, maxDes),
});

export const validationProposalLawyer = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras')
    .required(requiredField),
  lastName: Yup.string()
    .min(3, minName)
    .max(30, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras')
    .required(requiredField),
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(emptyError),
  cellphone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos'),
  estado: Yup.string(
      'Por favor, llenar el campo con un correo válido.'
    ).required(requiredField),
  municipio: Yup.string(
      'Por favor, llenar el campo con un correo válido.'
    ).required(requiredField),
  address: Yup.string()
    .required(requiredField),
})

export const validationExperienceProfile = Yup.object().shape({
  experience: Yup.string()
    .min(10, minDes)
    .max(2000, maxDes)
    .required(requiredField),
});

export const schemaSignIn = Yup.object().shape({
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(emptyError),
  password: Yup.string()
    .required(emptyError)
    .min(
      8,
      `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`
    )
    .max(
      16,
      `La contraseña debe tener entre ${8} y ${16} caracteres alfanuméricos`
    ),
});

export const schema2 = Yup.object().shape({
  email: Yup.string()
    .email('Por favor, llenar el campo con un correo válido.')
    .required(emptyError),
});

export const schemaClientInfo = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  lastName: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
});

export const validationClienteData = Yup.object().shape({
  email: Yup.string()
    .min(3, minEmail)
    .max(255, maxEmail)
    .email(invalidEmail)
    .required(requiredField),
  password: Yup.string()
    .min(8, minPassword)
    .max(16, maxPassword)
    .required(requiredField),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    'Debes aceptar los términos y condiciones'
  ),
});

export const validationClienteForm = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  email: Yup.string()
    .min(3, minEmail)
    .max(255, maxEmail)
    .email(invalidEmail)
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  description: Yup.string()
    .min(3, minDes)
    .max(1100, maxDes)
    .required(requiredField),
});

export const validationLandingForm = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(35, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  email: Yup.string()
    .min(3, minEmail)
    .max(255, maxEmail)
    .email(invalidEmail)
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  gender: Yup.string().required(requiredField),
});

export const validationLawyerForm = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(20, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  email: Yup.string()
    .min(3, minEmail)
    .max(255, maxEmail)
    .email(invalidEmail)
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  gender: Yup.string().required(requiredField),
});

export const validationSiteForm = Yup.object().shape({
  direccion: Yup.string().required(requiredField),

  phone: Yup.string().matches(
    /^[0-9]{10}$/,
    'Debe tener exactamente 10 dígitos númericos'
  ),
  estado: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
  municipio: Yup.string(
    'Por favor, llenar el campo con un correo válido.'
  ).required(requiredField),
});

export const validationVideoForm = Yup.object().shape({
  youtube: Yup.string()
    .min(10, minName)
    .max(100, maxName)
    .matches(youtube, 'Sólo se aceptan videos de Youtube') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
});

export const validationCost = Yup.object().shape({
  costoxasesoria: Yup.string().matches(
    /^[0-9]$/,
    'Debe tener exactamente 10 dígitos númericos'
  ),
  costoxhora: Yup.string().matches(
    /^[0-9]$/,
    'Debe tener exactamente 10 dígitos númericos'
  ),
});

export const validationOpinion = Yup.object().shape({
  opinion: Yup.string()
    .min(3, minOp)
    .max(100, maxOp)
    .required(requiredField),
});

export const validationBilling = Yup.object().shape({
  nameLawyerOrLawFirm: Yup.string()
    .required(requiredField),
  rfc: Yup.string()
    .required(requiredField),
  invoiceEmail: Yup.string()
    .email(invalidEmail)
    .required(requiredField),
  invoicePhoneNumber: Yup.string()
    .min(8, 'Debe tener entre 8 y 10 dígitos')
    .max(10, 'Debe tener entre 8 y 10 dígitos'),
  cfdi: Yup.string()
    .min(1, minArraySpecialties)
    .required(requiredField),
})


export const validationCard = Yup.object().shape({
  name: Yup.string()
    .required(requiredField),
  number: Yup.string()
    .required(requiredField)
    .min(14, 'Debe tener al menos 14 dígitos'),
  expiry: Yup.string()
    .required(requiredField),
  cvc: Yup.string()
    .required(requiredField),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    'Debes aceptar los términos y condiciones'
  ),
  contract: Yup.boolean().oneOf(
    [true],
    'Debes aceptar el contrato de Servicio de Contacta Abogado'
  ),
})

export const validationQuestions = Yup.object().shape({
  title:Yup.string()
  .required(requiredField),
  topic:Yup.string()
  .required(requiredField),
  details:Yup.string()
  .required(requiredField),
})

export const validationSearch = Yup.object().shape({
  search:Yup.string()
  .required(requiredField),
})

export const validationDummy = Yup.object().shape({
  
})

export const validationAppOpinion = Yup.object().shape({
  name: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') 
    .required(requiredField),
  email: Yup.string()
    .min(3, minEmail)
    .max(255, maxEmail)
    .email(invalidEmail)
    .required(requiredField),
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, 'Debe tener exactamente 10 dígitos númericos')
    .required(requiredField),
  commentary: Yup.string()
    .min(3, minOp)
    .max(1100, maxOp)
    .required(requiredField),
  termsAndConditions: Yup.boolean().oneOf(
    [true],
    'Debes aceptar los términos y condiciones'
  ),
});

export const validationAddProposalContact = Yup.object().shape({
    newContacts: Yup.array().of(Yup.object().shape({
      fullName: Yup.string()
        .min(3, minName)
        .max(40, maxName)
        .matches(textoyacentos, 'Sólo se aceptan letras') 
        .required(requiredField),
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Debe tener 10 dígitos'),
      typePhone: Yup.string().required(requiredField),
      email: Yup.string()
        .min(3, minEmail)
        .max(255, maxEmail)
        .email(invalidEmail),
  })),
});

export const validationAddingService = Yup.object().shape({  
  services: Yup.array().of(Yup.object().shape({
    description: Yup.string()
      .required(requiredField),
    price: Yup.number()
      // .matches(/^[0-9]$/, 'Debe ser un número')
      .lessThan(100001, 'El precio debe ser menor a 100000')
      .required(requiredField),
  })),
});


export const validationTitle = Yup.object().shape({
  titulo: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
  subTitulo: Yup.string()
    .min(3, minName)
    .max(40, maxName)
    .matches(textoyacentos, 'Sólo se aceptan letras') // .matches(/^[a-zA-Z ]*$/, 'Sólo se aceptan letrasx')
    .required(requiredField),
});